class ErrorMessages {
  public readonly NETWORK = 'Network Error: Unable to connect to the server.';
  public readonly BAD_REQUEST = 'Bad Request: The request is invalid or malformed.';
  public readonly UNAUTHORIZED = 'Unauthorized: You are not authorized to access this resource.';
  public readonly NOT_FOUND = 'Not Found: The requested resource was not found.';
  public readonly INTERNAL_SERVER = 'Internal Server Error: An unexpected error occurred on the server.';
  public readonly CUSTOM = 'Something went wrong.';
}

export const errorMessages = new ErrorMessages();
